import { Box, SxProps, Typography } from "@mui/material";
import React, { FC } from "react";

interface IEmptyGenericProps {
  description: string;
  sx?: SxProps;
  isVisits?: Boolean;
  nonTitle?: Boolean;
  title :string;
  image?: string;
  imageClassName?: string
}

const EmptyGeneric: FC<IEmptyGenericProps> = ({ description, sx, isVisits, nonTitle, title, image,
  imageClassName }) => {
  return <Box style={{ textAlign: "center", mixBlendMode: "multiply" }} sx={sx}>
    {isVisits ?
      <img
        src="/assets/icons/ilustration_empty_visits_2x.png"
        alt="visits empty state"
        className = { imageClassName }
      />:
      <div className="flex justify-center">
        <img
          src={image ? image : "/assets/icons/ilustration_empty_prescriptions_2x.jpg"}
          alt="prescriptions empty state"
          className={imageClassName}
        />
      </div>

    }

    {!nonTitle &&
      <Typography variant="h3" sx={{ pb: 1 }}>
        {title}
      </Typography>
    }

    <Typography variant="body1" className="text-base text-center">
      {description}
    </Typography>
  </Box>;
};

export default EmptyGeneric;
